import NewEndorsement from "components/Modal/Endorsement/NewEndorsement";
import { useModal } from "context/modal/modal.provider";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import { IMessage } from "types/Message.type";
import EndorsementItem from "./SideCard/EndorsementItem";

interface IEndorsementModal {
  messages: IMessage[];
}

const EndorsementModal: React.FC<IEndorsementModal> = ({ messages }) => {
  const { t } = useTranslation("celebration");
  const { openModal } = useModal();

  const handleEndorsement = (message: IMessage) => {
    openModal({
      eyebrow: t("Explore"),
      title: t("Agregar Validación"),
      description: t("Estas validando la habilidad de {{name}}", {
        name: message?.skill?.name ?? ""
      }),
      bodyClassName: "px-4 py-4 sm:px-5 sm:py-5",
      modalComponent: (
        <NewEndorsement
          skillId={message?.skill?.id ?? ""}
          userId={message?.createdBy?.id ?? ""}
          name={message?.skill?.name ?? ""}
        />
      ),
    });
  };

  const renderItems = () =>
    messages.map((message) => (
      <div
        className="w-full flex-none sm:w-1/2"
        key={`${message.id}_endorsement_modal`}
      >
        <EndorsementItem message={message} onEndorse={handleEndorsement} />
      </div>
    ));

  return (
    <div className="w-full rounded-lg bg-white p-8 dark:bg-gray-900">
      <div className="mb-2">
        <span className="text-lg font-semibold">{t("Validaciones")}</span>
      </div>

      <div className="mb-6 flex flex-wrap justify-start gap-y-4">
        <span className="mb-4 w-full flex-grow">
          {t("Ayuda a tus colaboradores validando sus habilidades")}
        </span>

        {renderItems()}
      </div>
    </div>
  );
};

export default EndorsementModal;
